import React, { useState } from 'react';
import BoxContainer from '../BoxContainer/BoxContainer';
import { useForm, Controller } from 'react-hook-form';
import get from 'lodash/get';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../CreateAccountWizard/updateAction';
import SsnToggleVisibilityField from '../SsnInput/SsnToggleVisibilityInput';
import { useUpdateClient } from '../../utils/service/service_user_api';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import {
  saveSensitiveData,
  getSensitiveData,
} from '../../utils/service/service_api';
import { useSensitiveData } from '../../contexts/sensitiveDataContext';

import {
  PaymintsButton,
  BUTTON_TYPE,
} from 'paymints-address-autocomplete-field';
import ErrorMessageInput from '../ErrorMessajeInput/ErrorMessageInput';
import { validSSN, validAge } from '../../utils/validations';
import { Select } from '../Select/Select';
import { states } from '../../utils/constants';
import '../CreateAccountWizard/createAccount.css';
import { encrypt } from '../../utils/encryption';
import css from '../../styles/modules/Account/account.module.css';
import useWindowWidth from '../../hooks/nonGQLhooks/useWindowWidth';

const Title = ({ client }) => (
  <div className="create-account__line-container">
    <div className="create-account__title">
      Now we need to verify your identity and you will be ready to connect your
      bank account.
    </div>
  </div>
);

const InfoSSN = () => (
  <div className="create-account__line-container">
    <div className="create-account__info-account">
      Now we need to verify your social security number and date of birth, and
      then we'll be ready to connect to your bank.
    </div>
  </div>
);

const nextStep = (history) => {
  history.push(`/bank-accounts`);
  window.location.reload();
};

const SecondStep = (props) => {
  const clientId = get(props, 'client._id');
  const tenantId = get(props, 'tenant._id');
  const { branding } = props;
  const intialform = { ...props.client, email: props.client?.email };
  const { register, handleSubmit, errors, control } = useForm({
    defaultValues: intialform,
  });

  const width = useWindowWidth();
  const { action } = useStateMachine(updateAction);
  const { updateClient } = useUpdateClient();
  const { sensitiveData, refetch: refetchSensitiveData } = useSensitiveData();
  const [border1, setBorder1] = useState(`1px solid ${branding?.accentColor}`);
  const [border2, setBorder2] = useState(`1px solid ${branding?.accentColor}`);
  const [border3, setBorder3] = useState(`1px solid ${branding?.accentColor}`);
  const [border4, setBorder4] = useState(`1px solid ${branding?.accentColor}`);
  const [border5, setBorder5] = useState(`1px solid ${branding?.accentColor}`);
  const [border6, setBorder6] = useState(`1px solid ${branding?.accentColor}`);
  const [border7, setBorder7] = useState(`1px solid ${branding?.accentColor}`);
  const [border8, setBorder8] = useState(`1px solid ${branding?.accentColor}`);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const onSubmit = async (newUser) => {
    const newUserWithoutSsnDash = {
      ...newUser,
      ssn: newUser.ssn.replace(/-/g, ''),
    };

    const { ssn, dateOfBirth, ...userValues } = newUserWithoutSsnDash;

    const sensitiveData = {
      SSN: encrypt(ssn),
      DOB: encrypt(dateOfBirth),
    };
    try {
      await saveSensitiveData(clientId, tenantId, sensitiveData);
      const dataSENS = await getSensitiveData(clientId, tenantId);
      await updateClient({
        variables: {
          id: clientId,
          client: userValues,
        },
      });

      await props.refetch({ mobilePhone: props?.client?.mobilePhone });
      await refetchSensitiveData();
      await action({ client: newUser });
      nextStep(props.history);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={css.wrapper}>
      <BoxContainer withDoubleBorder withLogButton widest withTopLogo>
        <Title client={props.client} />
        <InfoSSN />
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={css.formWrapper}>
            <div className={css.subWrapper}>
              <h5 style={{ marginTop: '40px' }} className={css.wrapperLabel}>
                Personal Information
              </h5>

              <div
                style={{
                  boxShadow: `0vw 3px 3px ${branding?.accentColor?.replace(
                    /[\d.]+\)$/g,
                    '0.25)',
                  )}`,
                }}
                className={css.textFieldSub2}
              >
                <div className={css.fullWidthFieldContainer}>
                  <div className={css.inputContainerFullWidth}>
                    <p className={css.tagLabelFullWidth}>
                      {width <= 1024
                        ? 'SSN (last 4 digits)'
                        : 'Last 4 Digits of Social Security Number'}
                    </p>
                    <div className={css.inputIconWrapperFullWidth}>
                      <input
                        type={isPasswordVisible ? 'text' : 'password'}
                        placeholder="Social Security Number"
                        id="ssn"
                        name="ssn"
                        maxLength={4}
                        ref={register({ required: false, validate: validSSN })}
                        className={css.textFieldSmall}
                        onFocus={() =>
                          setBorder1(`2px solid ${branding?.accentColor}`)
                        }
                        onBlur={() =>
                          setBorder1(`1px solid ${branding?.accentColor}`)
                        }
                        style={{ border: border1, outline: 'none' }}
                      />
                      <span onClick={togglePasswordVisibility}>
                        {isPasswordVisible ? (
                          <AiFillEye className={css.togglePasswordIcon} />
                        ) : (
                          <AiFillEyeInvisible
                            className={css.togglePasswordIcon}
                          />
                        )}
                      </span>
                    </div>
                    {errors.firstName &&
                      errors.firstName.type === 'required' && (
                        <ErrorMessageInput>This is required</ErrorMessageInput>
                      )}
                    {errors.firstName &&
                      errors.firstName.type === 'maxLength' && (
                        <ErrorMessageInput>
                          Max length exceeded
                        </ErrorMessageInput>
                      )}
                  </div>
                </div>
                <div className={css.fullWidthFieldContainer}>
                  <div className={css.inputContainerFullWidth}>
                    <p className={css.tagLabelFullWidth}>Date of Birth</p>
                    <input
                      type="date"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      placeholder="yyyy-mm-dd"
                      ref={register({ required: false, validate: validAge })}
                      className={css.textFieldSmall}
                      onFocus={() =>
                        setBorder2(`2px solid ${branding?.accentColor}`)
                      }
                      onBlur={() =>
                        setBorder2(`1px solid ${branding?.accentColor}`)
                      }
                      style={{
                        border: border2,
                        outline: 'none',
                        paddingRight: '20px',
                      }}
                    />
                  </div>
                </div>
                <div className={css.fullWidthFieldContainer}>
                  <div className={css.inputContainerFullWidth}>
                    <p className={css.tagLabelFullWidth}>Email</p>
                    <input
                      type="email"
                      placeholder=" "
                      id="email"
                      name="email"
                      ref={register({ maxLength: 50 })}
                      className={css.textFieldSmall}
                      onFocus={() =>
                        setBorder3(`2px solid ${branding?.accentColor}`)
                      }
                      onBlur={() =>
                        setBorder3(`1px solid ${branding?.accentColor}`)
                      }
                      style={{ border: border3, outline: 'none' }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className={css.subWrapper}>
              <h5 className={css.wrapperLabel}>
                Address Associated with Bank Account
              </h5>

              <div
                style={{
                  boxShadow: `0vw 3px 3px ${branding?.accentColor?.replace(
                    /[\d.]+\)$/g,
                    '0.25)',
                  )}`,
                }}
                className={css.textFieldSub2}
              >
                <div className={css.fullWidthFieldContainer}>
                  <div className={css.inputContainerFullWidth}>
                    <p className={css.tagLabelFullWidth}>Street Address</p>
                    <input
                      type="text"
                      name="address1"
                      placeholder="Street Address"
                      className={css.textFieldSmall}
                      autoComplete="no"
                      ref={register({ required: false })}
                      onFocus={() =>
                        setBorder4(`2px solid ${branding?.accentColor}`)
                      }
                      onBlur={() =>
                        setBorder4(`1px solid ${branding?.accentColor}`)
                      }
                      style={{ border: border4, outline: 'none' }}
                    />
                  </div>
                </div>

                <div className={css.fullWidthFieldContainer}>
                  <div className={css.inputContainerFullWidth}>
                    <p className={css.tagLabelFullWidth}>Unit # / Apt #</p>
                    <input
                      type="text"
                      name="address2"
                      placeholder="Unit # / Apt #"
                      className={css.textFieldSmall}
                      autoComplete="no"
                      ref={register({ required: false })}
                      onFocus={() =>
                        setBorder5(`2px solid ${branding?.accentColor}`)
                      }
                      onBlur={() =>
                        setBorder5(`1px solid ${branding?.accentColor}`)
                      }
                      style={{ border: border5, outline: 'none' }}
                    />
                  </div>
                </div>

                <div className={css.fullWidthFieldContainer}>
                  <div className={css.inputContainerFullWidth}>
                    <p className={css.tagLabelFullWidth}>City</p>
                    <input
                      type="text"
                      name="city"
                      placeholder="City"
                      className={css.textFieldSmall}
                      autoComplete="no"
                      ref={register({ required: false })}
                      onFocus={() =>
                        setBorder6(`2px solid ${branding?.accentColor}`)
                      }
                      onBlur={() =>
                        setBorder6(`1px solid ${branding?.accentColor}`)
                      }
                      style={{ border: border6, outline: 'none' }}
                    />
                  </div>
                </div>

                <div className={css.fullWidthFieldContainer}>
                  <div className={css.inputContainerFullWidth}>
                    <p className={css.tagLabelFullWidth}>State</p>
                    <select
                      className={css.textFieldSmall}
                      id="state"
                      name="state"
                      onFocus={() =>
                        setBorder7(`2px solid ${branding?.accentColor}`)
                      }
                      onBlur={() =>
                        setBorder7(`1px solid ${branding?.accentColor}`)
                      }
                      style={{ border: border7, outline: 'none' }}
                      ref={register({ required: false })}
                    >
                      {states.map((item) => {
                        return (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
                <div className={css.fullWidthFieldContainer}>
                  <div className={css.inputContainerFullWidth}>
                    <p className={css.tagLabelFullWidth}>Zip Code</p>
                    <input
                      type="text"
                      name="zipcode"
                      placeholder="Zip Code"
                      className={css.textFieldSmall}
                      autoComplete="no"
                      ref={register({ required: false })}
                      onFocus={() =>
                        setBorder8(`2px solid ${branding?.accentColor}`)
                      }
                      onBlur={() =>
                        setBorder8(`1px solid ${branding?.accentColor}`)
                      }
                      style={{ border: border8, outline: 'none' }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className=" d-flex justify-content-center mt-5">
            <PaymintsButton
              htmlType="submit"
              className="create-account__button"
              noShadow
              type={BUTTON_TYPE.INVERSE_BLUE}
            >
              Verify
            </PaymintsButton>
          </div>
        </form>
      </BoxContainer>
    </div>
  );
};

export default withRouter(connect((state) => ({}), {})(SecondStep));
